module.exports = __webpack_public_path__ + "img/img-120.9b1613a4.png";